module.exports = __webpack_public_path__ + "img/energetic1.8a82c7c1.png";